import React, { useState } from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { DefaultModal } from 'components/Modals/DefaultModal';
import { useGetBlockSlidesQuery } from 'store/apis/teamsApi';

export const ImageSection = ({
  classes,
  Content,
  title,
  slidesCount,
  onHeaderClick,
  currentSample,
}) => {
  const [thumbnailModalOpen, setThumbnailModalOpen] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [slideName, setSlideName] = useState(null);
  const { data: slides } = useGetBlockSlidesQuery(
    { blockUUID: currentSample.uuid },
    { skip: !currentSample },
  );
  const handleThumbnailOpen = (thumbnail, newSlideName) => {
    setSlideName(newSlideName);
    setThumbnailUrl(thumbnail);
    setThumbnailModalOpen(true);
  };

  const handleThumbnailClose = () => {
    setThumbnailModalOpen(false);
    setThumbnailUrl(null);
    setSlideName(null);
  };

  const headerClassName = `${classes.slideSectionText} ${
    onHeaderClick ? classes.clickable : ''
  }`;

  const slidesForCurrentSample = slides || [];
  const currentSlidesCount = slidesForCurrentSample.length;

  return (
    <>
      <Box mb={1} ml={4}>
        {!!currentSlidesCount && Content && (
          <Box
            className={classes.imageSectionHeader}
            onClick={() => onHeaderClick(slidesForCurrentSample)}
          >
            <Typography className={headerClassName}>{title}</Typography>
            <Box className={classes.counter}>{currentSlidesCount}</Box>
          </Box>
        )}
        <Box mt={2} mr={4}>
          <Grid container spacing={2} className={classes.images}>
            {slidesForCurrentSample.map((slide, index) => (
              <Grid
                item
                xs={4}
                sm={3}
                md={4}
                key={slide.uuid}
                className={classes.slideCard}
              >
                {Content ? (
                  <>
                    <Content isBrief slide={slide} />
                    <Typography className={classes.slideName}>
                      <Typography
                        component="span"
                        className={classes.orderName}
                      >
                        {index + 1}. {currentSample.name} /{' '}
                      </Typography>
                      {slide.name}
                    </Typography>
                  </>
                ) : (
                  <Box
                    className={classes.barcodeContainer}
                    onClick={() =>
                      handleThumbnailOpen(slide.large_macro_url, slide.name)
                    }
                  >
                    <img
                      src={slide.small_macro_url}
                      alt={slide.name}
                      width="100%"
                    />
                  </Box>
                )}
                {!slidesCount && (
                  <Typography className={classes.barcodeText}>
                    {`${currentSample.projectName} / ${currentSample.name} / ${slide.name}`}
                  </Typography>
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <DefaultModal
        open={thumbnailModalOpen}
        onClose={handleThumbnailClose}
        isLimitedHeight
      >
        <Box className={classes.centered}>
          <img
            className={classes.fullImage}
            src={thumbnailUrl}
            alt={slideName}
          />
        </Box>
      </DefaultModal>
    </>
  );
};
